@if (site$ | async) {
  <span>
    {{ 'recaptcha.protectedBy' | cxTranslate }}
    <a href="https://policies.google.com/privacy">{{ 'recaptcha.privacyPolicy' | cxTranslate }}</a> {{ 'recaptcha.and' | cxTranslate }}
    <a href="https://policies.google.com/terms">{{ 'recaptcha.termsOfService' | cxTranslate }}</a> {{ 'recaptcha.apply' | cxTranslate }}
  </span>
}
